import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout(props) {
  return (
    <>
        <Header adminData={props.adminData} setAdminData={props.setAdminData} />
        <Outlet />
        <Footer />
    </>
  )
}
